<template>
  <div class="cell cell-contractor" contenteditable="false">
    <div
      v-if="noOffers"
      class="cell-contractor__content cell-contractor__new-tender"
      @click="createNewTender"
    >
      <Icon type="plus" color="accent" size="16" />
      <div>{{ $t('Add to tender') }}</div>
    </div>
    <div
      v-else-if="!!priceSourcesCompanies"
      class="cell-contractor__content cell-contractor__winner"
      @click="goToTender"
    >
      <Icon type="check" color="success" size="16" />
      <div class="text-ellipsis">{{ priceSourcesCompanies }}</div>
    </div>
    <div
      v-else-if="offeredTeams.length"
      class="cell-contractor__content cell-contractor__submitted"
      @click="goToTender"
    >
      <Badge rounded color="grey">
        {{ offeredTeams.length }}
      </Badge>
      <div class="text-ellipsis">{{ getOffersTeams(offeredTeams) }}</div>
    </div>
    <div
      v-else-if="otherTeams.length"
      class="cell-contractor__content cell-contractor__in-progress"
      @click="goToTender"
    >
      <Icon type="refresh" size="16" />
      <div class="text-ellipsis">{{ getOffersTeams(otherTeams) }}</div>
    </div>
  </div>
</template>

<script>
  import Badge from '@/components/ui/Badge';
  import createTender from '@/utils/mixins/create-tender';
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'ContractorCell',
    components: {
      Badge,
      Icon,
    },
    mixins: [createTender],
    props: {
      contractor: {
        type: Object,
        required: true,
      },
      listId: Number,
      rowId: Number,
      priceSources: Array,
    },
    computed: {
      showCreateNewTender() {
        return !this.contractor?.id;
      },
      offeredTeams() {
        return this.contractor?.tender?.tender_offers?.filter(
          (offer) => offer.status === 'offered'
        );
      },
      otherTeams() {
        return this.contractor?.tender?.tender_offers?.filter(
          (offer) => offer.status !== 'offered'
        );
      },
      noOffers() {
        return !this.contractor.id || !this.contractor?.tender?.tender_offers?.length;
      },
      priceSourcesCompanies() {
        return this.priceSources
          ?.map((source) => source.tender_offer_version?.tender_offer?.contractor_team.name)
          ?.filter((source) => !!source)
          .join(', ');
      },
    },
    methods: {
      async createNewTender() {
        await this.$router.push({
          name: 'tenders',
          params: { status: 'active' },
          query: { tab: this.listId },
        });

        await this.createTender({
          row_ids: [this.rowId],
        });
      },
      goToTender() {
        this.$router.push({
          name: 'tender-summary',
          params: { tenderId: this.contractor?.tender_id },
        });
      },
      getOffersTeams(offers = []) {
        return offers?.map((offer) => offer.contractor_team.name).join(', ');
      },
    },
  };
</script>

<style scoped lang="scss">
  @import 'src/styles/colors';

  .cell-contractor {
    cursor: pointer !important;

    &__content {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-weight: 500;
      font-size: 14px;

      > * + * {
        margin-left: 6px;
      }
    }

    &__new-tender {
      color: $text-accent;
    }

    &__in-progress,
    &__submitted,
    &__winner {
      color: $text-secondary;
    }
  }
</style>
